import { gql } from "graphql-request";
import { apiSlice } from "./apiSlice";

export const RbacApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchUsersByRole: builder.query({
      query: ({ roleId, uid }: any) => ({
        customuuid: uid,
        url: "/graphql",
        body: gql`
          query {
            fetchUsersByRole(roleId: "${roleId}") {
              timestamp
              error
              version
              data {
                users {
                  name {
                    fullName
                  }
                  employment {
                    band
                  }
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Utility" }
    }),
    fetchRoleByUserId: builder.query({
      query: (userId: string) => ({
        customuuid: userId,
        url: `/rbac/role/${userId}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
  })
});

export const {
  useLazyFetchRoleByUserIdQuery,
  useLazyFetchUsersByRoleQuery,
} = RbacApiSlice;
